<section class="highlighted">
	<picture>
		<source media="(min-width: 992px)" [srcset]="slider.image" *ngIf="slider.image">
		<img [src]="slider.cover" *ngIf="slider.cover">
	</picture>

	<div class="highlighted__content">
		<!-- <div class="description">{{ slider.description }}</div> -->
		<div class="slider">
			<ngx-slick-carousel class="carousel center" #slickModal="slick-carousel" [config]="slideConfig">
				<div ngxSlickItem *ngFor="let item of slider.items" class="slide">
					<div class="image-container landscape rounded">
						<a (click)="goToVideo(item.slug)">
							<picture>
								<img [src]="item.image">
							</picture>

							<div class="episode" *ngIf="item.episode">
								<span>{{ item.episode }}</span>
							</div>
						</a>
					</div>
					<div class="video-title" [innerHTML]="item.title + ' - ' + item.subtitle | safeHtml"></div>
				</div>
			</ngx-slick-carousel>
		</div>
	</div>
</section>